module.exports = __webpack_public_path__ + "img/huangpu.7b88e2be.jpg";